// import required libraries
import $ from "jquery";

// import components that run on every page
import detailsDefaultBlock from "./components/detailsDefaultBlock";

// Import Pages
import accessibility from './actions/accessibility';
import renderHeader from './actions/renderHeader';
import renderHighlights from './actions/renderHighlights';
import renderPerformancePosters from './actions/renderPerformancePosters';
import performanceSlider from './components/performanceSlider';
import renderImageSlider from './actions/renderImageSlider';
import renderTestimonials from './actions/renderTestimonials';
import renderSearchbar from './actions/renderSearchbar';
import renderVideoOnScroll from './actions/renderVideoOnScroll';
import renderHeroVideo from './actions/renderVideoHero';
import renderTabsSection from './actions/renderTabsSection';
import banner from "./blocks/banner";
import stats from "./components/stats";

// render header
renderHeader($);
renderSearchbar($);

// call functions
accessibility();
detailsDefaultBlock();
renderHighlights($);
renderPerformancePosters($);
performanceSlider($);
renderImageSlider($);
renderTestimonials($);
renderVideoOnScroll($);
renderHeroVideo($);
renderTabsSection($);
banner();
stats();
